module.exports = __webpack_public_path__ + "img/ubicacion.9899da08.gif";